import React from 'react';
import styled from 'styled-components';
import { AttachmentApi } from '../../api/attachment.api';
import { useComponentDidMount } from '../../utils/hooks';
import { useRootStore } from '../../App';

const StyledImg = styled.img`
  display: block;
  margin-left: auto;
  margin-right: auto;
  max-width: 100%;
  max-height: 1000px;
  object-fit: cover;
`;

interface Props {
  fileId: string;
  fileName: string;
}

export const AttachmentThumbnailImg = (props: Props) => {
  const root = useRootStore();
  const [isLoading, setIsLoading] = React.useState(true);
  const [img, setImg] = React.useState<string>('');
  const { fileId, fileName } = props;

  const getImg = async () => {
    try {
      setIsLoading(true);
      const data = await AttachmentApi.getAttachment(fileId, fileName);
      setImg(data);
      setIsLoading(false);
    } catch (e) {
      console.error(e);
      root.inquiryPageStore.setFailedLoadingInquiryData(true);
    }
  };

  useComponentDidMount(() => {
    getImg();
  });

  return isLoading ? null : <StyledImg src={img} alt={fileName} />;
};
